module.exports = __webpack_public_path__ + "img/tripBg.0ef251ed.png";